// The game trailer shown by the home page's WATCH TRAILER button (src/ui/trailerModal.js).
// To change the trailer: put the new YouTube video's id here (the part after "v=" in its link), or — to play a file instead —
// put the .mp4's path in `mp4` (e.g. '/video/mao-kingdom-trailer.mp4', with the file in /public/video/). If `mp4` is set it wins.
export const TrailerConfig = Object.freeze({
  youtubeId: 'b-wzZgw9SOY', // "2026 Mao Kingdom RPG Trailer" (https://youtu.be/b-wzZgw9SOY) — public, embedding allowed
  mp4: '',
})
